import styled from 'styled-components'

const Error = styled.p`
    color: red;
    margin-bottom: 1rem;
`

export default Error
